// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"76747837","54":"427ae6ed","271":"b789f401","318":"ef6b04e6","340":"b577da4d","395":"4d8ec49d","527":"be8c5245","647":"c2311a76","944":"83762a57","953":"ef8c63f9"}[chunkId] + ".chunk.js";
};